export const addItemshoppingCartAction = (product, quantity, subCategory) => {
	return {
		type: 'ADD_ITEM',
		item: product,
		quantity: quantity,
		subCategory: subCategory
	};
};

export const deleteItemshoppingCartAction = (product) => {
	return {
		type: 'DELETE_ITEM',
		item: product
	};
};

export const addCategoryAction = (category) => {
	return {
		type: 'ADD_CATEGORY',
		item: category
	};
};

export const addShopInfoAction = (shopUid) => {
	return {
		type: 'ADD_SHOP_UID',
		item: shopUid
	};
};

export const addCategoriesProductsAction = (data) => {
	return {
		type: 'ADD_CATEGORIES_products',
		item: data
	};
};

export const addFooterItemAction = (data) => {
	return {
		type: 'ADD_FOOTER_ITEM',
		item: data
	};
};

